export function Loader() {
  return (
    <div class="absolute right-1/2 bottom-1/2  transform translate-x-1/2 translate-y-1/2 h-24 w-24">
      <div class="border-t-transparent border-solid animate-spin rounded-full dark:text-gray-600 fill-navy-700 border-8 h-16 w-16" />
    </div>
  );
}
